import { useExperience } from "../../../../../shared/context/ExperienceContext";

import {
  benefitsContentByMode,
  benefitCardsByMode,
  ArrowRightIcon,
} from "./data/benefitsData";

import BenefitsHeading from "./components/BenefitsHeading/BenefitsHeading";
import BenefitsGrid from "./components/BenefitsGrid/BenefitsGrid";
import BenefitsCommitment from "./components/BenefitsCommitment/BenefitsCommitment";

import "./BenefitsSection.css";

export default function BenefitsSection() {
  const { mode } = useExperience();

  const benefitsContent =
    benefitsContentByMode[mode] || benefitsContentByMode.all;

  const cards = benefitCardsByMode[mode] || benefitCardsByMode.all;

  return (
    <section className="benefits-section">
      <div className="container">
        <BenefitsHeading content={benefitsContent} />

        <BenefitsGrid cards={cards} />

        <BenefitsCommitment
          content={benefitsContent}
          ArrowIcon={ArrowRightIcon}
        />
      </div>
    </section>
  );
}